<h4 class="title-2 mb-4" data-test-id="homebound-details">Homebound Details</h4>
<form [formGroup]="homeboundForm">
  <p-panel
    class="mb-12"
    header="Does the member's status meet CMS definition of homebound?"
    [toggleable]="false"
    data-test-id="homebound-details-header"
    >
    <div class="grid grid-cols-12 gap-4 p-2">
      <div class="col-span-6 lg:col-span-3">
        <div class="flex items-center">
          <p-radio-button
            class="isHomebound primary"
            name="isHomebound"
            [value]="true"
            inputId="isHomebound_yes"
            formControlName="isHomebound"
            data-test-id="is-homebound"
          />
          <label for="isHomebound_yes" class="ml-2">Member Is Homebound</label>
        </div>
      </div>
      <div class="col-span-6">
        <div class="flex items-center">
          <p-radio-button
            class="isNotHomebound primary"
            name="isHomebound"
            [value]="false"
            inputId="isHomebound_no"
            formControlName="isHomebound"
            data-test-id="is-not-homebound"
          />
          <label for="isHomebound_no" class="ml-2">Member Is Not Homebound</label>
        </div>
      </div>
      <div class="col-span-12">
        <p>
          <em data-test-id="houmbound-status">
            *CMS Homebound status: Homebound status certified by MD, leaving the
            home is a considerable and taxing effort, infrequent and short
            duration or are attributable to receive health care treatment
          </em>
        </p>
      </div>
    </div>
  </p-panel>
  <p-panel
    class="mb-4"
    header="Is there an able/willing/teachable caregiver?"
    [toggleable]="false"
    data-test-id="caregiver"
    >
    <div class="grid grid-cols-12 gap-4">
      <div class="col-span-3">
        <div class="flex items-center">
          <p-radio-button
            name="teachable"
            value="yes"
            inputId="teachable_yes"
            formControlName="teachable"
            class="primary teachableYes"
            data-test-id="caregiver-yes"
          />
          <label for="teachable_yes" class="ml-2">Yes</label>
        </div>
      </div>
      <div class="col-span-3">
        <div class="flex items-center">
          <p-radio-button
            name="teachable"
            value="no"
            inputId="teachable_no"
            formControlName="teachable"
            class="primary teachableNo"
            (onClick)="removeValue()"
            data-test-id="caregiver-no"
          />
          <label for="teachable_no" class="ml-2">No</label>
        </div>
      </div>
      <div class="col-span-6">
        <div class="flex items-center">
          <p-radio-button
            name="teachable"
            value="unknown"
            inputId="teachable_unknown"
            formControlName="teachable"
            class="primary"
            (onClick)="removeValue()"
            data-test-id="caregiver-unknown"
          />
          <label for="teachable_unknown" class="ml-2">Unknown</label>
        </div>
      </div>
    </div>
  </p-panel>

  @if (homeboundForm?.controls['teachable'].value === 'yes') {
    <p-panel
      header="Enter Caregiver Details"
      data-test-id="caregiver-details"
    >
      <textarea
        class="resize-y w-full"
        rows="5"
        cols="100"
        formControlName="careGiverDetail"
        pInputTextarea
        trimInputValue
        data-test-id="caregiver-details-textarea"
      ></textarea>
    </p-panel>
  }
</form>
